import React from 'react';
const ErrorPage = ({ errorType, customMessage }) => {
  const errorMessages = {
      qnxt: 'QNXT System returned an error. Please try later.',
    customreports: 'Error loading Custom Reports. Please try again later.',
    cca: 'Error loading CCAArchival. Please try again later.',
    insignia: 'Error loading Insignia. Please try again later.',
    tcare: 'Error loading TCare. Please try again later.',
    clinicalprofile: 'Error loading ClinicalProfile. Please try again later.',
      periscope: 'Error loading Periscope. Please try again later.',
      caresync: 'Error loading CareSync. Please try again later.',
      trualta: 'Error loading Trualta. Please try again later.',
    esign: 'Error loading eSign Dashboard. Please try again later.',
    adtd: 'Error loading ADT Dashboard. Please try again later.',
    findhelp: 'Error loading Find Help. Please try again later.',
    ict: 'Error loading ICT Portal. Please try again later.',
    mcare: 'Error loading MCare. Please try again later.',
      mhint: 'Error loading MHint. Please try again later.',
      aiml: 'Error loading AIML. Please try again later.',
      membermerge: 'Error loading Member Merge. Please try again later.',
    optum: 'Error loading Optum Impact Pro. Please try again later.',
    pegaltss: 'Error loading Pega LTSS. Please try again later.',
      salesforce: 'Error loading Salesforce M360. Please try again later.',
      salesforcepcp: 'Error loading Salesforce PCP. Please try again later.',
    servicetable: 'Error loading Service Table. Please try again later.',
    ssbci: 'Error loading SSBCI. Please try again later.',
    default: 'An error occurred. Please try again later.'
  };
  const getMessage = () => {
    if (customMessage) return customMessage;
    return errorMessages[errorType] || errorMessages.default;
  };
  return (
    <div 
      data-testid="error-page" 
      data-error-type={errorType}
      style={{color: 'red', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}
    >
      {getMessage()}
    </div>
  );
};
export default ErrorPage;
